var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLiveStreamsicon = function SvgLiveStreamsicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.343 4.938a1 1 0 0 1 0 1.415 8.003 8.003 0 0 0 0 11.317 1 1 0 1 1-1.414 1.414c-3.907-3.906-3.907-10.24 0-14.146a1 1 0 0 1 1.414 0m12.732 0c3.906 3.907 3.906 10.24 0 14.146a1 1 0 0 1-1.415-1.414 8.003 8.003 0 0 0 0-11.317 1 1 0 1 1 1.415-1.415M9.31 7.812a1 1 0 0 1 0 1.414 3.92 3.92 0 0 0 0 5.544 1 1 0 1 1-1.415 1.414 5.92 5.92 0 0 1 0-8.372 1 1 0 0 1 1.415 0m6.958 0a5.92 5.92 0 0 1 0 8.372 1 1 0 0 1-1.414-1.414 3.92 3.92 0 0 0 0-5.544 1 1 0 0 1 1.414-1.414m-4.186 2.77a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
  })));
};
export default SvgLiveStreamsicon;